// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"not-found-m__wrapper__snN2a","status":"not-found-m__status__NkLdt","status-message":"not-found-m__status-message__1aRaK","button":"not-found-m__button__28fMG"};